import { AuthService } from "./AuthService"

export interface Error {
  message: string
}

export class HttpService {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async get<T>(path: string): Promise<T> {
    return this.fetchWithJsonHeader(path).then((data) => data as T);
  }

  async post<T>(path: string, data: any): Promise<T> {
    return this.fetchWithJsonHeader(path, {
      method: "POST",
      body: JSON.stringify(data),
    }).then((data) => data as T);
  }

  async postForm<T>(path: string, formData: FormData): Promise<T> {
    return this.fetchWithoutHeader(path, {
      method: "POST",
      body: formData,
    }).then((data) => data as T);
  }

  async put<T>(path: string, data: any): Promise<T> {
    return this.fetchWithJsonHeader(path, {
      method: "PUT",
      body: JSON.stringify(data),
    }).then((data) => data as T);
  }

  async delete(path: string, data: any) {
    return this.fetchWithJsonHeader(path, {
      method: "DELETE",
      body: JSON.stringify(data),
    });
  }

  private async fetchWithoutHeader(path: string, init?: RequestInit) {
    let headers: any = {};
    return this.fetch(path, headers, init);
  }

  private async fetchWithJsonHeader(path: string, init?: RequestInit) {
    let headers: any = { "Content-Type": "application/json" };
    return this.fetch(path, headers, init);
  }

  private async fetch(path: string, headers: any, init?: RequestInit) {
    const user = await AuthService.getUser();
    if (user && user.access_token) {
      headers["Authorization"] = "Bearer " + user.access_token;
    }

    return fetch(this.baseUrl + path, { ...init, headers })
      .then((response) => {
        if (response.ok) {
          if (response.status !== 204) {
            return response.json();
          }
        } else {
          return response.json().then((error) => Promise.reject<Error>(error));
        }
      })
      .catch((error) => Promise.reject<Error>(error));
  }
}
